(function () {
	'use strict';

	var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

	$('[data-redirect-onchange]').change(function () {
		window.location = $(this).val();
	});
})();
